export default {
  oilSampleElements: [
    {
      abbreviation: 'Cu',
      name: 'Copper'
    },
    {
      abbreviation: 'Fe',
      name: 'Iron'
    },
    {
      abbreviation: 'Cr',
      name: 'Chromium'
    },
    {
      abbreviation: 'Al',
      name: 'Aluminum'
    },
    {
      abbreviation: 'Pb',
      name: 'Lead'
    },
    {
      abbreviation: 'Sn',
      name: 'Tin'
    },
    {
      abbreviation: 'Si',
      name: 'Silicon'
    },
    {
      abbreviation: 'Ca',
      name: 'Calcium'
    },
    {
      abbreviation: 'Mg',
      name: 'Magnesium'
    },
    {
      abbreviation: 'Zn',
      name: 'Zinc'
    },
    {
      abbreviation: 'P',
      name: 'Phosphorus'
    },
    {
      abbreviation: 'Mo',
      name: 'Molybdenum'
    },
    {
      abbreviation: 'B',
      name: 'Boron'
    },
    {
      abbreviation: 'Ag',
      name: 'Silver'
    },
    {
      abbreviation: 'Ni',
      name: 'Nickel'
    },
    {
      abbreviation: 'Na',
      name: 'Sodium'
    },
    {
      abbreviation: 'K',
      name: 'Potassium'
    }
  ],
  coolantSampleElements: [
    {
      abbreviation: 'Cu',
      name: 'Copper'
    },
    {
      abbreviation: 'Fe',
      name: 'Iron'
    },
    {
      abbreviation: 'Al',
      name: 'Aluminum'
    },
    {
      abbreviation: 'Pb',
      name: 'Lead'
    },
    {
      abbreviation: 'Sn',
      name: 'Tin'
    },
    {
      abbreviation: 'Si',
      name: 'Silicon'
    },
    {
      abbreviation: 'Ca',
      name: 'Calcium'
    },
    {
      abbreviation: 'Mg',
      name: 'Magnesium'
    },
    {
      abbreviation: 'Zn',
      name: 'Zinc'
    },
    {
      abbreviation: 'P',
      name: 'Phosphorus'
    },
    {
      abbreviation: 'Mo',
      name: 'Molybdenum'
    },
    {
      abbreviation: 'B',
      name: 'Boron'
    },
    {
      abbreviation: 'Na',
      name: 'Sodium'
    },
    {
      abbreviation: 'K',
      name: 'Potassium'
    }
  ]
};
